import { LineBreakTransformer } from "./LineBreakTransformer";
import { ParsedWeightData, Weighbridge } from "./Weighbridge";

export class LD5204Weighbridge implements Weighbridge {
    public baudRate: number = 2400;
    public lineBreakSeparator: string = '\r';
    public lineBreakTransformer?: LineBreakTransformer;

    public parse(buffer: string): ParsedWeightData {
        const modes = [buffer.slice(0, 1), buffer.slice(1, 2)];
        const weight = parseInt(buffer.slice(2, 8));
        const unit = 'kg';

        return {
            modes,
            weight,
            unit,
        };
    }
    
    public getLineBreakTransformer() {
        return this.lineBreakTransformer ??= new LineBreakTransformer(this.lineBreakSeparator);
    }
}